define(['./_root'], function(root) {

  /** Built-in value references. */
  var Uint8Array = root.Uint8Array;

  return Uint8Array;
});
